module.exports = __webpack_public_path__ + "img/653d858.png";